<template>
  <div class="pdt-20px">
    <div class="columns">
      <div class="column is-8">
        <app-info-collaborateur :infoUser="infoUser"
                                @editAgenceRattachement="editAgenceRattachement()"
        ></app-info-collaborateur>
      </div>
      <div class="column is-4">
        <app-identifiant-connexion :infoUser="infoUser" :isAdd="isAdd"></app-identifiant-connexion>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('firstStepUtilisateur.signature.title')}}
            </p>
          </header>
          <div class="card-content">
            <qd-text-editor v-model="infoUser.signatureEmail" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppInfoCollaborateur from './firstStep/informationCollaborateur';
import AppIdentifiantConnexion from './firstStep/identifiantConnexion';

export default {
  props: {
    infoUser: Object,
    isAdd: Boolean,
  },
  components: {
    AppInfoCollaborateur,
    AppIdentifiantConnexion,
  },
  methods: {
    editAgenceRattachement() {
      this.$emit('editAgenceRattachement');
    },
  },
};
</script>

<style scoped>

</style>
